import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { addQueryParam } from '../../../utils/commonfunction';

const pageLinkBaseStyle = {
  minWidth: "34px",
  height: "34px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 10px",
  fontSize: "13px",
  lineHeight: 1,
  boxSizing: "border-box",
  userSelect: "none",
};

const CustomPagination = (props) => {
  const params = useParams();
  const [query] = useSearchParams();
  const navigate = useNavigate();
  const pages = [];

  const datalength = Number(props.datalength ?? props.total ?? 0) || 0;
  const itemperpage = Number(props.itemperpage ?? props.pageSize ?? props.itemsPerPage ?? 10) || 10;
  const currentPage = Number(props.currentPage ?? props.current ?? 1) || 1;
  const setPage = props.setPage || props.onChange || (() => {});
  const isModalOrDirect = Boolean(props.modalPagination || (!props.pageRoute && !props.query && !props.custompath));

  let pageno = currentPage;
  if (!isModalOrDirect) {
    if (props.query) {
      pageno = props.custompath ? Number(params[props.custompath]) : Number(query.get(props.paramName || 'page'));
    } else {
      pageno = props.custompath ? Number(params[props.custompath]) : Number(params.pgno);
    }
  }
  pageno = Number(pageno) || currentPage || 1;

  const totalPages = Math.max(1, Math.ceil(datalength / itemperpage));

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setPage(totalPages);
      if (!isModalOrDirect) {
        if (props.query) {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (addQueryParam(props.pageRoute[0].path, props.paramName || 'page', totalPages)) : ("#"));
        } else {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (props.pageRoute[0].path + '/' + totalPages) : ("/#"));
        }
      }
    }
  }, [totalPages, navigate, props, currentPage, isModalOrDirect, setPage]);

  let start = pageno || 1;
  if (start < 1) {
    start = 1;
  } else {
    if (start < 5) {
      start = 1;
    } else {
      start = start - 3;
    }
  }
  let end = start + 6;
  end = end <= totalPages ? end : totalPages;
  if (start > end) {
    start = Math.max(1, end - 6);
  }

  for (let i = start; i <= end; i++) {
    if (!isNaN(i) && i >= 1 && i <= totalPages) {
      pages.push(i);
    }
  }

  const handleprepage = () => {
    if (Number(pageno) > 1) {
      const prevPage = Number(pageno) - 1;
      setPage(prevPage);
      if (!isModalOrDirect) {
        if (props.query) {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (addQueryParam(props.pageRoute[0].path, props.paramName || 'page', prevPage)) : ("#"));
        } else {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (props.pageRoute[0].path + '/' + prevPage) : ("/#"));
        }
      }
    }
  };

  const handlePagniation = (target) => {
    const p = Number(target);
    if (p && !isNaN(p) && p >= 1 && p <= totalPages && p !== Number(pageno)) {
      setPage(p);
      if (!isModalOrDirect) {
        if (props.query) {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (addQueryParam(props.pageRoute[0].path, props.paramName || 'page', p)) : ("#"));
        } else {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (props.pageRoute[0].path + '/' + p) : ("/#"));
        }
      }
    }
  };

  const handleNextpage = () => {
    if (Number(pageno) < totalPages) {
      const nextPage = Number(pageno) + 1;
      setPage(nextPage);
      if (!isModalOrDirect) {
        if (props.query) {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (addQueryParam(props.pageRoute[0].path, props.paramName || 'page', nextPage)) : ("#"));
        } else {
          navigate(props && props.pageRoute && props.pageRoute[0]?.path ? (props.pageRoute[0].path + '/' + nextPage) : ("/#"));
        }
      }
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center">
      <nav aria-label="Pagination">
        <ul className="pagination mb-0 align-items-center">
          {/* Previous Button */}
          <li className={`page-item ${Number(pageno) <= 1 ? "disabled" : ""}`}>
            <button
              type="button"
              className="page-link"
              onClick={handleprepage}
              disabled={Number(pageno) <= 1}
              style={{
                ...pageLinkBaseStyle,
                cursor: Number(pageno) <= 1 ? "not-allowed" : "pointer",
                opacity: Number(pageno) <= 1 ? 0.45 : 1,
              }}
              aria-label="Previous"
            >
              ‹
            </button>
          </li>

          {/* First Page Link */}
          {start > 1 && (
            <>
              <li className={`page-item ${Number(pageno) === 1 ? "active" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handlePagniation(1)}
                  style={{
                    ...pageLinkBaseStyle,
                    backgroundColor: Number(pageno) === 1 ? "#097969" : undefined,
                    borderColor: Number(pageno) === 1 ? "#097969" : undefined,
                    color: Number(pageno) === 1 ? "#ffffff" : undefined,
                    fontWeight: Number(pageno) === 1 ? 600 : 400,
                  }}
                >
                  1
                </button>
              </li>
              {start > 2 && (
                <li className="page-item disabled">
                  <span
                    className="page-link"
                    style={{
                      ...pageLinkBaseStyle,
                      cursor: "default",
                      backgroundColor: "transparent",
                    }}
                  >
                    …
                  </span>
                </li>
              )}
            </>
          )}

          {/* Page Numbers */}
          {pages.map((pgno) => {
            const isActive = Number(pageno) === pgno;
            return (
              <li key={pgno} className={`page-item ${isActive ? "active" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handlePagniation(pgno)}
                  style={{
                    ...pageLinkBaseStyle,
                    backgroundColor: isActive ? "#097969" : undefined,
                    borderColor: isActive ? "#097969" : undefined,
                    color: isActive ? "#ffffff" : undefined,
                    fontWeight: isActive ? 600 : 400,
                  }}
                >
                  {pgno}
                </button>
              </li>
            );
          })}

          {/* Last Page Link */}
          {end < totalPages && (
            <>
              {end < totalPages - 1 && (
                <li className="page-item disabled">
                  <span
                    className="page-link"
                    style={{
                      ...pageLinkBaseStyle,
                      cursor: "default",
                      backgroundColor: "transparent",
                    }}
                  >
                    …
                  </span>
                </li>
              )}
              <li className={`page-item ${Number(pageno) === totalPages ? "active" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={() => handlePagniation(totalPages)}
                  style={{
                    ...pageLinkBaseStyle,
                    backgroundColor: Number(pageno) === totalPages ? "#097969" : undefined,
                    borderColor: Number(pageno) === totalPages ? "#097969" : undefined,
                    color: Number(pageno) === totalPages ? "#ffffff" : undefined,
                    fontWeight: Number(pageno) === totalPages ? 600 : 400,
                  }}
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}

          {/* Next Button */}
          <li className={`page-item ${Number(pageno) >= totalPages ? "disabled" : ""}`}>
            <button
              type="button"
              className="page-link"
              onClick={handleNextpage}
              disabled={Number(pageno) >= totalPages}
              style={{
                ...pageLinkBaseStyle,
                cursor: Number(pageno) >= totalPages ? "not-allowed" : "pointer",
                opacity: Number(pageno) >= totalPages ? 0.45 : 1,
              }}
              aria-label="Next"
            >
              ›
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default CustomPagination;